<template>
  <div class="mock">
    <div class="header">
      <span class="header-left">mock地址:</span>
      <span class="header-middle">
        https://www.hualazimi.xyz/mock/
      </span>
      <input class="header-right" v-model="inputPath" />
    </div>

    <div class="request">
      <span class="request-top">请求参数:</span>
      <div class="request-body" contenteditable="true"></div>
    </div>

    <div class="response">
      <span class="response-top">返回参数:</span>
      <div class="response-body" contenteditable="true"></div>
    </div>

    <div class="button" @click="submit">提交</div>
  </div>
</template>

<script>
import { ref, getCurrentInstance } from "vue";
export default {
  setup() {
    const { ctx } = getCurrentInstance();
    console.log(`router`, ctx.$router);
    const inputPath = ref("");
    const submit = () => {
      const requestBody = document.querySelector(".request-body").innerHTML;
      const responseBody = document.querySelector(".response-body").innerHTML;

      if (
        inputPath.value.trim() === "" ||
        requestBody.trim() === "" ||
        responseBody.trim() === ""
      ) {
        alert("请输入完整数据");
        return;
      }

      console.log(
        `输入信息:inputPath,requestBody, responseBody`,
        inputPath.value,
        requestBody,
        responseBody
      );

      try {
        //   JSON.parse(requestBody);
        JSON.parse(responseBody);
      } catch (error) {
        console.error("error:", error);
        alert("请输入json格式");
        return;
      }

      fetch("http://www.hualazimi.xyz/apiservice/mock", {
        body: JSON.stringify({inputPath: inputPath.value, responseBody}),
        cache: "no-cache",
        // credentials: "include",
        headers: {
          "content-type": "application/json"
        },
        method: "POST",
        mode: "cors"
      })
        .then(res => res.json())
        .then(res => {
          if (res.body === 1) alert("mock地址生成成功");
          else alert("mock地址生成异常");
        })
        .catch(err => console.error("err", err));
    };
    return { inputPath, submit };
  }
};
</script>

<style lang="less" scoped>
.header {
  // padding: 15px;
  margin-bottom: 20px;
  height: 30px;
  box-sizing: border-box;
  border: 1px solid #eed;
  line-height: 30px;
  &-left {
    font-weight: bold;
    margin-right: 10px;
  }
  &-middle {
    color: grey;
    background: rgba(0, 0, 0, 0.1);
    border-radius: 1px;
  }
  &-right {
    outline: none;
    border: none;
    hieght: 30px;
  }
}

.request,
.response {
  margin: 15px 0;
  &-top {
    font-weight: bold;
    margin: 5px;
  }
  &-body {
    height: 200px;
    box-sizing: border-box;
    border: 1px solid #eed;
    overflow: scroll;
  }
}

.button {
  width: 250px;
  margin: 65px auto;
  height: 50px;
  border-radius: 5px;
  background: red;
  color: white;
  font-size: 20px;
  line-height: 50px;
  cursor: pointer;
}
</style>
